import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBInput,
} from "mdb-react-ui-kit";
import { useMessageBox } from "../components/Common/MessageBox";

const ProductDetailsPage = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { showSuccess, MessageBoxComponent } = useMessageBox();

  // Use the enriched product from previous page
  const [editableProduct, setEditableProduct] = useState(
    state?.product || null,
  );

  if (!editableProduct) {
    return <p className="text-center mt-5">No product data found</p>;
  }

  const { marketplaces } = editableProduct;
  const localFields = marketplaces?.local || {};

  // Update top-level fields (optional)
  const handleLocalFieldChange = (key, value) => {
    setEditableProduct((prev) => ({
      ...prev,
      marketplaces: {
        ...prev.marketplaces,
        local: { ...prev.marketplaces.local, [key]: value },
      },
    }));
  };

  // Update any marketplace field
  const handleMarketplaceChange = (market, key, value) => {
    setEditableProduct((prev) => ({
      ...prev,
      marketplaces: {
        ...prev.marketplaces,
        [market]: { ...prev.marketplaces[market], [key]: value },
      },
    }));
  };

  const handleSave = () => {
    console.log("Saved Product:", editableProduct);
    showSuccess("Changes saved! (Check console for object)");
  };

  return (
    <MDBContainer className="py-4">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h3>Product Details</h3>
        <MDBBtn color="danger" outline onClick={() => navigate(-1)}>
          Back
        </MDBBtn>
      </div>

      {/* General Information */}
      <div
        className="mb-4 p-4 rounded shadow-sm"
        style={{ background: "#fff", borderLeft: "4px solid #dc3545" }}
      >
        <h5 className="text-danger mb-4">General Information</h5>
        <MDBRow>
          {[
            "Title",
            "Description",
            "Price",
            "Category",
            "Condition",
            "Quantity",
            "SKU",
            "Brand",
          ].map((key) => (
            <MDBCol md="6" lg="4" className="mb-3" key={key}>
              <MDBInput
                label={key}
                value={localFields[key] || ""}
                onChange={(e) => handleLocalFieldChange(key, e.target.value)}
              />
            </MDBCol>
          ))}
        </MDBRow>
      </div>

      {/* Marketplace Panels */}
      {Object.entries(marketplaces).map(([market, fields]) => (
        <div
          key={market}
          className="mb-4 p-4 rounded shadow-sm"
          style={{ background: "#fff", borderLeft: "4px solid #dc3545" }}
        >
          <h5 className="text-danger mb-4 text-capitalize">{market} Listing</h5>

          <MDBRow>
            {Object.entries(fields).map(([key, value]) => (
              <MDBCol md="6" lg="4" className="mb-3" key={key}>
                <MDBInput
                  label={key}
                  value={value || ""}
                  onChange={(e) =>
                    handleMarketplaceChange(market, key, e.target.value)
                  }
                />
              </MDBCol>
            ))}
          </MDBRow>
        </div>
      ))}

      {/* Action Buttons */}
      <div className="d-flex justify-content-end gap-2 mt-4">
        <MDBBtn color="danger" onClick={handleSave}>
          Save Changes
        </MDBBtn>
        <MDBBtn color="danger" outline onClick={() => navigate(-1)}>
          Cancel
        </MDBBtn>
      </div>
      <MessageBoxComponent />
    </MDBContainer>
  );
};

export default ProductDetailsPage;
